import React from 'react';

import Logo from '../../assets/images/logo.png';
import BaseImage from '../../components/base/base-image';
import AppButton from '../../components/base/button';
import AuthFooter from '../../layout/component/auth-footer';
import { FiLogOut } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store';

const KYBVerificationFailed: React.FC = () => {
  const navigate = useNavigate();
  const { removeAuthStateFromStorage } = useAuthStore();

  const logout = () => {
    removeAuthStateFromStorage();
    navigate('/login');
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white email-verified-bg">
      <div className="max-w-md p-6 bg-transparent text-center">
        <div className="flex justify-center mb-4">
          <BaseImage imgSrc={Logo} imgAlt="ryno" imgClass="mb-4 w-32" />
        </div>
        <h1 className="text-2xl font-bold text-red-500 mb-4">
          KYB Verification Failed
        </h1>
        <p className="mb-16 font-normal">
          We regret to inform you that your business verification (KYB) has not
          been approved. Due to our compliance policies, you cannot submit
          another KYB application at this time.
        </p>

        {/* <div className="bg-gray-50 rounded-xl p-4 mb-16">
          <p className="font-semibold text-center mb-2">What happens next?</p>
          <ul className="text-sm font-normal text-left list-disc pl-5 space-y-2">
            <li>Your business account will remain restricted</li>
            <li>You cannot initiate new transactions</li>
            <li>Existing transactions will be processed as per regulations</li>
          </ul>
        </div> */}

        <p className="text-center text-sm mb-4">
          If you believe this is an error or need assistance, please contact our
          support team.
        </p>
        <AppButton label="Contact Support" />
        <div className="flex items-center gap-2 text-red-500 text-sm my-4 cursor-pointer justify-center">
          <FiLogOut />
          <p onClick={logout}>Logout</p>
        </div>
      </div>

      <AuthFooter />
    </div>
  );
};

export default KYBVerificationFailed;
